import { useEffect, useState } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IntegracionService } from "../../../../../services/auxiliar/IntegracionService";
import { IEquipoModeloSync, IPostEquipoModelo } from "../../../../../Interfaces/estadoEquipos/IEstadoEquipo";

export const UsePanelEquipoModeloSync=(props:IOpenPanel)=>{
    const [LoadingSincronizar,setLoadingSincronizar]=useState<boolean>(false)
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [equipoModelosSync,setEquipoModelosSync]=useState<IEquipoModeloSync[]>([])
    const reset=()=>{
        setMensaje("")
        setStatus(0)
        props.onDismiss()
    }
    const getEquipoModelos=()=>{
        setLoadingSincronizar(true)
        IntegracionService.GetEquipoModelos().then((res)=>{
            if(res.status==200){
             setLoadingSincronizar(false)
             setEquipoModelosSync(res.data)
            }
         }).catch((e)=>{
             setLoadingSincronizar(false)
         })
    }
    useEffect(()=>{
        if(props.isOpen){
            getEquipoModelos()
        }
    },[props.isOpen])
    const SyncronizarEquipoModelos=()=>{
        setLoading(true)
        const request:IPostEquipoModelo={
            listaModelos: equipoModelosSync
        }
        IntegracionService.PostEquipoModelo(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(() => {
                    props.reload?.();
                    reset()
                }, 3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {status,loading,mensaje,SyncronizarEquipoModelos,getEquipoModelos,reset,LoadingSincronizar,equipoModelosSync}
}